export default "__VITE_ASSET__C3nGXgHv__"